import { render, staticRenderFns } from "./TasksMadeV2.vue?vue&type=template&id=165cf0b6&scoped=true"
import script from "./TasksMadeV2.vue?vue&type=script&lang=js"
export * from "./TasksMadeV2.vue?vue&type=script&lang=js"
import style0 from "./TasksMadeV2.vue?vue&type=style&index=0&id=165cf0b6&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165cf0b6",
  null
  
)

export default component.exports